import { useSelector } from "react-redux";
import UserInfo from "components/organisms/UserInfo";
import * as authSelectors from "redux/auth/selectors";
import * as userSelectors from "redux/user/selectors";
import { useChatwootInit } from "hooks/useChatwootInit";
import { useCountriesStore } from "stores/countries";
import { useSplitServiceData } from "queries/useSplitServiceData";
import { useGetUserMascots } from "queries/useGetUserMascots";

const UserInfoContainer = () => {
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const { balance, bonus } = useSelector(userSelectors.all);
  const isCountriesOpen = useCountriesStore((state) => state.isCountriesOpen);
  const { loyaltyAccess } = useSplitServiceData();
  const chatWootInit = useChatwootInit();
  const { data: mascotsUser } = useGetUserMascots();
  const activeMascot = mascotsUser?.data?.data?.find(
    (mascot) => mascot.status === "active",
  );

  return (
    <UserInfo
      balance={balance}
      bonus={bonus}
      isAuthenticated={isAuthenticated}
      isCountriesOpen={isCountriesOpen}
      chatWootInit={chatWootInit}
      showLoyaltyAvatar={loyaltyAccess}
      avatar={activeMascot?.link}
    />
  );
};

export default UserInfoContainer;
